import {
  API_URI,
} from "constants/config";
import store from "constants/store";
import sessionToken from "selectors/sessionToken";
export const BASE_URL = `${API_URI.replace('/graphql', '')}/rest`;

export const getConditionsByExternalIdProgramId = (
  externalId: string,
  programId: string,
) => {
  const token = sessionToken(store.getState());
  if (!token) {
    throw new Error("No authentication token available");
  }
  const url = `${BASE_URL}/conditions?externalId=${externalId}&programId=${programId}`;
  return [
    url,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    },
  ];
};

const ConditionService = {
  getConditionsByExternalIdProgramId,
};

export default ConditionService;
